const TZ = 'Europe/Berlin';
const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;
const RELATIVE = ['heute', 'morgen', 'übermorgen'];

function berlinParts(date) {
  const parts = new Intl.DateTimeFormat('de-DE', {
    timeZone: TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    weekday: 'short',
    hourCycle: 'h23',
  }).formatToParts(date);
  return Object.fromEntries(parts.map((part) => [part.type, part.value]));
}

function dayNumber(parts) {
  return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)) / DAY_MS;
}

export function deliveryDeadline(now, hours = 24) {
  return new Date(now.getTime() + hours * HOUR_MS);
}

export function deliveryLabel(now, hours = 24) {
  const start = berlinParts(now);
  const end = berlinParts(deliveryDeadline(now, hours));
  const diff = dayNumber(end) - dayNumber(start);
  const relative = RELATIVE[diff] ?? `in ${diff} Tagen`;
  return `${relative}, ${end.weekday} ${end.day}.${end.month}., um ${end.hour}:${end.minute} Uhr`;
}

export function shortDate(date) {
  const parts = berlinParts(date);
  return `${parts.weekday}, ${parts.day}.${parts.month}.`;
}

if (typeof customElements !== 'undefined' && !customElements.get('sf-delivery-countdown')) {
  customElements.define('sf-delivery-countdown', class extends HTMLElement {
    connectedCallback() {
      this.render();
      this.timer = setInterval(() => this.render(), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    render() {
      const target = this.querySelector('[data-sf-deadline]');
      if (target) target.textContent = deliveryLabel(new Date(), Number(this.dataset.hours || 24));
    }
  });
}
